import LOGO_PREIN from '../_img/logo_edison.png'

// PREIN愛媛本番環境
export const URL_BASE='https://drone-ehime.prein.jp/'
export const AWS_S3_BUCKET_NAME='prod-drone-ehime-contents'
export const COPYRIGHT_TEXT ='© Inspiration.Plus'
export const LOGO_IMG = LOGO_PREIN
export const SERVICE_NAME = 'EDISON'
export const DEFAULT_LAT = 33.841641
export const DEFAULT_LNG = 132.765658
export const MANUAL = 'edison_drone_manual_ver1.pdf'